<!-- 商户管理/商户申请列表 -->
<template>
  <el-table :data="tableData" style="width: 100%;border: 1px solid #f1f1f1">
    <el-table-column sortable label="编号" align="center" prop="id" width="80">
    </el-table-column>
    <el-table-column label="商户" align="center" prop="merch_name">
    </el-table-column>
    <el-table-column label="联系人" align="center">
      <template slot-scope="scope">
        <div class="table_scope_line">联系人：{{ scope.row.contact_name }}</div>
        <div class="table_scope_line">联系方式：{{ scope.row.contact_mobile }}</div>
      </template>
    </el-table-column>
    <el-table-column label="创建时间" align="center" prop="createtime">
    </el-table-column>
    <el-table-column label="状态" align="center" prop="apply_status">
    </el-table-column>
    <el-table-column label="操作" align="center">
      <template slot-scope="scope">
        <div class="table_button_line">
          <el-button type="text" @click="infor(scope.row)">详情</el-button>
          <el-button type="text" @click="apply(scope.$index)">通过</el-button>
          <el-button type="text" @click="refuse(scope.$index)">驳回</el-button>
        </div>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
export default {
  props: {
    tableData: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  methods:{
    apply(i){
      console.log(i)
      this.$emit('apply',i)
    },
    refuse(i){
      this.$emit('refuse',i)
    }
  }
};
</script>
